
            const data = {"name":"add-circle-1-1","data":{"width":"512","height":"512","viewBox":"85 43 342 426","data":"<path pid=\"0\" d=\"M256 43C138 43 43 138 43 256s95 213 213 213 213-95 213-213S374 43 256 43zm0 384c-94 0-171-77-171-171S162 85 256 85s171 77 171 171-77 171-171 171zm21-278h-42v86h-86v42h86v86h42v-86h86v-42h-86z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    